import * as Types from '../../types';

import { gql } from '@apollo/client';
import { AddressDisplayFragmentDoc } from '../../components/AddressDisplay/AddressDisplay.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBlockTransactionsQueryVariables = Types.Exact<{
  number: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  filters?: Types.InputMaybe<Array<Types.FilterInput> | Types.FilterInput>;
  sort?: Types.InputMaybe<Types.SortInput>;
}>;

export type GetBlockTransactionsQuery = {
  __typename?: 'Query';
  block?: {
    __typename?: 'Block';
    number: number;
    transactions: {
      __typename?: 'TransactionConnection';
      totalCount: number;
      pageInfo: {
        __typename?: 'PageInfo';
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
        endCursor?: string | null;
      };
      edges: Array<{
        __typename?: 'TransactionEdge';
        cursor: string;
        node: {
          __typename?: 'Transaction';
          hash: string;
          nonce: number;
          transactionIndex?: number | null;
          value: Array<number>;
          valueEth: any;
          valueUsd?: any | null;
          gas: number;
          gasPrice?: any | null;
          maxFeePerGas?: any | null;
          maxPriorityFeePerGas?: any | null;
          maxFeePerBlobGas?: any | null;
          input: string;
          chainId?: number | null;
          status: Types.TransactionStatus;
          to?: {
            __typename?: 'Address';
            address: string;
            entity?: {
              __typename?: 'Entity';
              id: any;
              name: string;
              risks: {
                __typename?: 'EntityRiskConnection';
                totalCount: number;
                pageInfo: {
                  __typename?: 'PageInfo';
                  hasNextPage: boolean;
                  hasPreviousPage: boolean;
                  startCursor?: string | null;
                  endCursor?: string | null;
                };
                edges: Array<{
                  __typename?: 'EntityRiskEdge';
                  node: {
                    __typename?: 'EntityRisk';
                    id: any;
                    riskType: string;
                    severity: string;
                    description?: string | null;
                  };
                }>;
              };
            } | null;
            risks: {
              __typename?: 'AddressRiskConnection';
              totalCount: number;
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                hasPreviousPage: boolean;
                startCursor?: string | null;
                endCursor?: string | null;
              };
              edges: Array<{
                __typename?: 'AddressRiskEdge';
                node: {
                  __typename?: 'AddressRisk';
                  id: any;
                  riskType: string;
                  severity: string;
                  description?: string | null;
                };
              }>;
            };
          } | null;
          from: {
            __typename?: 'Address';
            address: string;
            entity?: {
              __typename?: 'Entity';
              id: any;
              name: string;
              risks: {
                __typename?: 'EntityRiskConnection';
                totalCount: number;
                pageInfo: {
                  __typename?: 'PageInfo';
                  hasNextPage: boolean;
                  hasPreviousPage: boolean;
                  startCursor?: string | null;
                  endCursor?: string | null;
                };
                edges: Array<{
                  __typename?: 'EntityRiskEdge';
                  node: {
                    __typename?: 'EntityRisk';
                    id: any;
                    riskType: string;
                    severity: string;
                    description?: string | null;
                  };
                }>;
              };
            } | null;
            risks: {
              __typename?: 'AddressRiskConnection';
              totalCount: number;
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                hasPreviousPage: boolean;
                startCursor?: string | null;
                endCursor?: string | null;
              };
              edges: Array<{
                __typename?: 'AddressRiskEdge';
                node: {
                  __typename?: 'AddressRisk';
                  id: any;
                  riskType: string;
                  severity: string;
                  description?: string | null;
                };
              }>;
            };
          };
        };
      }>;
    };
  } | null;
};

export const GetBlockTransactionsDocument = gql`
  query GetBlockTransactions(
    $number: Int!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filters: [FilterInput!]
    $sort: SortInput
  ) {
    block(number: $number) {
      number
      transactions(
        after: $after
        before: $before
        first: $first
        last: $last
        filters: $filters
        sort: $sort
      ) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          cursor
          node {
            hash
            nonce
            transactionIndex
            to {
              ...AddressDisplay
            }
            from {
              ...AddressDisplay
            }
            value
            valueEth
            valueUsd
            gas
            gasPrice
            maxFeePerGas
            maxPriorityFeePerGas
            maxFeePerBlobGas
            input
            chainId
            status
          }
        }
      }
    }
  }
  ${AddressDisplayFragmentDoc}
`;

/**
 * __useGetBlockTransactionsQuery__
 *
 * To run a query within a React component, call `useGetBlockTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockTransactionsQuery({
 *   variables: {
 *      number: // value for 'number'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetBlockTransactionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBlockTransactionsQuery,
    GetBlockTransactionsQueryVariables
  > &
    (
      | { variables: GetBlockTransactionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBlockTransactionsQuery,
    GetBlockTransactionsQueryVariables
  >(GetBlockTransactionsDocument, options);
}
export function useGetBlockTransactionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBlockTransactionsQuery,
    GetBlockTransactionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBlockTransactionsQuery,
    GetBlockTransactionsQueryVariables
  >(GetBlockTransactionsDocument, options);
}
export function useGetBlockTransactionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetBlockTransactionsQuery,
        GetBlockTransactionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetBlockTransactionsQuery,
    GetBlockTransactionsQueryVariables
  >(GetBlockTransactionsDocument, options);
}
export type GetBlockTransactionsQueryHookResult = ReturnType<
  typeof useGetBlockTransactionsQuery
>;
export type GetBlockTransactionsLazyQueryHookResult = ReturnType<
  typeof useGetBlockTransactionsLazyQuery
>;
export type GetBlockTransactionsSuspenseQueryHookResult = ReturnType<
  typeof useGetBlockTransactionsSuspenseQuery
>;
export type GetBlockTransactionsQueryResult = Apollo.QueryResult<
  GetBlockTransactionsQuery,
  GetBlockTransactionsQueryVariables
>;
